const projects = [
    {
        name: "Most to Coast",
        icon: "https://user-images.githubusercontent.com/95199209/184752237-608d70da-4d21-4434-82a0-80babd45d2e2.jpg",
        description: "A Travel Planner App that will reduce travel planning time. Users can plan out their trips at ease based on other users' plans in the Feed.",
        github: "https://github.com/mikyurkev/Most_to_Coast_v2",
        // deployment: "https://most-to-coast.herokuapp.com/",
        technologies: ['React.js', 'MongoDB', 'Express.js','Node.js', 'GraphQL', 'JWT', 'Apollo-Server']
    },

    {
        name: "Moat",
        icon: "https://user-images.githubusercontent.com/95199209/184752268-a65d9abf-9009-46da-96c3-78a01e667aa9.jpg",
        github: "https://github.com/utorteam11/MOAT",
        description: "A custom rental property management solution, which allows a property manager to create a platform for their tenants to communicate upwards.",
        // deployment: "https://moatbyoceans11.herokuapp.com/",
        technologies: ['REST API', 'mySQL', 'Express.js','Node.js', 'handlebars']
    },

    {
        name: "Latest Pitch",
        icon: "https://user-images.githubusercontent.com/102537904/162641342-c94cbe01-f5cd-4900-8b45-108e6018e745.png",
        github: "https://github.com/utorteam13/Team13_Project1",
        description: "A Soccer Scoreboard designed to help soccer/football fans to track the live scores/past scores and standing of teams of their favourite leagues.",
        deployment: "https://utorteam13.github.io/Team13_Project1/",
        technologies: ['HTML', 'CSS', 'JS', 'DOM Manipulation']
    }
]

module.exports = projects;